import React, { useState, useEffect } from "react";
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  TextField, 
  List, 
  ListItem, 
  ListItemAvatar, 
  Avatar, 
  ListItemText, 
  InputAdornment, 
  IconButton,
  Typography,
  Box,
  Button
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import { getchatuserlist } from "../../slice/usersSlice";

const ForwardModal = ({ open, onClose, onForward, message }) => {
  const dispatch = useDispatch();
  const { getchatuser, status } = useSelector((state) => state.users);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUserForForward, setSelectedUserForForward] = useState(null);

  useEffect(() => {
    if (open) {
      dispatch(getchatuserlist());
    }
  }, [open, dispatch]);

  const filteredUsers = getchatuser?.filter(u => 
    u.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          width: '100%',
          maxWidth: '400px',
          maxHeight: '500px'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        background: '#2a78d1',
        color: '#FFFFFF',
        py: 1.5
      }}>
        <Typography sx={{ fontWeight: 700, fontSize: '16px' }}>Forward Message</Typography>
        <IconButton onClick={onClose} size="small" sx={{ color: '#FFFFFF' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 2, borderBottom: '1px solid #F1F5F9' }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search people..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: '18px', color: '#94A3B8' }} />
                </InputAdornment>
              ),
              sx: { borderRadius: '12px', background: '#F8FAFC', fontSize: '13px' }
            }}
          />
        </Box>

        <List sx={{ pt: 0, maxHeight: '350px', overflowY: 'auto' }}>
          {filteredUsers?.map((user) => (
            <ListItem 
              button 
              key={user._id} 
              onClick={() => setSelectedUserForForward(user._id)}
              sx={{ 
                px: 2, 
                py: 1.5,
                transition: 'all 0.2s ease',
                background: selectedUserForForward === user._id ? '#F0F9FF' : 'transparent',
                '&:hover': { background: '#F0F9FF' }
              }}
            >
              <ListItemAvatar>
                <Avatar 
                  src={user.profileImage || ""}
                  sx={{ bgcolor: '#E0F2FE', color: '#0369A1', fontSize: '14px', fontWeight: 700 }}
                >
                  {user.name?.[0].toUpperCase()}
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#1E293B' }}>{user.name}</Typography>}
                secondary={<Typography sx={{ fontSize: '11px', color: '#94A3B8' }}>{selectedUserForForward === user._id ? "Confirm sending?" : "Click to select"}</Typography>}
              />
              {selectedUserForForward === user._id && (
                <Button 
                  variant="contained" 
                  size="small" 
                  onClick={(e) => {
                    e.stopPropagation();
                    onForward(user);
                    setSelectedUserForForward(null);
                  }}
                  sx={{ textTransform: 'none', borderRadius: '8px', bgcolor: '#4F46E5', '&:hover': { bgcolor: '#4338CA' } }}
                >
                  Send
                </Button>
              )}
            </ListItem>
          ))}
          {filteredUsers?.length === 0 && (
            <Box sx={{ p: 4, textAlign: 'center' }}>
              <Typography sx={{ color: '#94A3B8', fontSize: '13px' }}>No users found</Typography>
            </Box>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default ForwardModal;
